module.exports = __webpack_public_path__ + "img/logos.6829c0a9.png";